module.exports = __webpack_public_path__ + "static/scale-model-of-elitch-gardens-in-lakewood-colorado-c42a0f944b033dd125e5a609058d14a6.png";